import { useEffect, useState } from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import { apiVariable } from "../../../api/apiVariable";

const ProcessedByHrSwitch = ({
  id,
  isHrProcessed,
  isDisabled = false,
}: {
  id: string;
  isHrProcessed: boolean;
  isDisabled?: boolean;
}) => {
  const { token } = useAuth();
  const queryClient = useQueryClient();
  const [checked, setChecked] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    setChecked(isHrProcessed || false);
  }, [isHrProcessed]);

  const mutation = useMutation({
    mutationFn: (value: boolean) =>
      axios.put(`${apiVariable}/setProcessedByHR/${id}`, null, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          isHrProcessed: value,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["timeOffRequests"] });
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response?.data || "Failed to update request");
    },
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setChecked(value);
    mutation.mutate(value);
  };

  return (
    <div>
      <FormControlLabel
        control={<Switch checked={checked} onChange={handleChange} />}
        disabled={isDisabled}
        label=""
      />
      {status === "error" && <p style={{ color: "red" }}>{errorMessage}</p>}
    </div>
  );
};

export default ProcessedByHrSwitch;
